// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cvat-feedback-button{position:absolute;bottom:20px;right:20px;padding:0}.cvat-feedback-button>i{font-size:40px}\n", ""]);
// Exports
module.exports = exports;
